import { render, staticRenderFns } from "./StockCountProducts.vue?vue&type=template&id=42454a0a&scoped=true"
import script from "./StockCountProducts.vue?vue&type=script&lang=js"
export * from "./StockCountProducts.vue?vue&type=script&lang=js"
import style0 from "./StockCountProducts.vue?vue&type=style&index=0&id=42454a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42454a0a",
  null
  
)

export default component.exports